module.exports = __webpack_public_path__ + "img/guide.ec1b3d0c.png";